<template>
  <div>
    <label class="switch">
      <input
        class="switch-input"
        type="checkbox"
        :disabled="isDisable"
        :checked="isChecked"
        @click="clickHandler($event)"
      />
      <span class="switch-label"></span>
      <span class="switch-handle"></span>
    </label>
  </div>
</template>
<style scoped>
.switch {
  position: relative;
  display: block;
  vertical-align: top;
  width: 34px;
  height: 14px;
  padding: 3px;
  margin: 0;
  background: linear-gradient(to bottom, #eeeeee, #ffffff 25px);
  background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff 25px);
  border-radius: 18px;
  cursor: pointer;
  box-sizing: content-box;
}
.switch .switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  box-sizing: content-box;
}
.switch .switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 10px;
  text-transform: uppercase;
  background: #eceeef;
  border-radius: inherit;
  box-sizing: content-box;
}
.switch-label:before,
.switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -0.5em;
  line-height: 1;
  -webkit-transition: inherit;
  -moz-transition: inherit;
  -o-transition: inherit;
  transition: inherit;
  box-sizing: content-box;
}
.switch-label:before {
  content: attr(data-off);
  right: 11px;
  color: #aaaaaa;
}
.switch-label:after {
  content: attr(data-on);
  left: 11px;
  color: #ffffff;
  opacity: 0;
}
.switch-input:checked ~ .switch-label {
  background: rgba(10, 128, 32, 0.38);
}
.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}
.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}
.switch-handle {
  position: absolute;
  top: -1px;
  left: 0px;
  width: 20px;
  height: 20px;
  background: linear-gradient(to bottom, #ffffff 40%, #f0f0f0);
  background-image: -webkit-linear-gradient(top, #ffffff 40%, #f0f0f0);
  border-radius: 100%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}
.switch-handle:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -6px 0 0 -6px;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
}
.switch-input:checked ~ .switch-handle {
  left: 18px;
  background: #0a8020;
}

.switch-label,
.switch-handle {
  transition: All 0.3s ease;
  -webkit-transition: All 0.3s ease;
  -moz-transition: All 0.3s ease;
  -o-transition: All 0.3s ease;
}
.switch-input:disabled ~ .switch-handle {
  opacity: 1;
  cursor: not-allowed;
  display: inline-block;
  background-position: center;
  background-size: 70%;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjA4MzMgNi40MTY1SDIuOTE2NjdDMi4yNzIzMyA2LjQxNjUgMS43NSA2LjkzODg0IDEuNzUgNy41ODMxN1YxMS42NjY1QzEuNzUgMTIuMzEwOCAyLjI3MjMzIDEyLjgzMzIgMi45MTY2NyAxMi44MzMySDExLjA4MzNDMTEuNzI3NyAxMi44MzMyIDEyLjI1IDEyLjMxMDggMTIuMjUgMTEuNjY2NVY3LjU4MzE3QzEyLjI1IDYuOTM4ODQgMTEuNzI3NyA2LjQxNjUgMTEuMDgzMyA2LjQxNjVaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC4wODM1IDYuNDE2NVY0LjA4MzE3QzQuMDgzNSAzLjMwOTYyIDQuMzkwNzkgMi41Njc3NiA0LjkzNzc3IDIuMDIwNzhDNS40ODQ3NSAxLjQ3Mzc5IDYuMjI2NjEgMS4xNjY1IDcuMDAwMTYgMS4xNjY1QzcuNzczNzEgMS4xNjY1IDguNTE1NTggMS40NzM3OSA5LjA2MjU2IDIuMDIwNzhDOS42MDk1NCAyLjU2Nzc2IDkuOTE2ODMgMy4zMDk2MiA5LjkxNjgzIDQuMDgzMTdWNi40MTY1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K");
}

.switch-input:disabled ~ .switch-label {
  opacity: 1;
  cursor: not-allowed;
}
</style>
<script>
export default {
  name: "ToggleButton",
  props: {
    isChecked: {
      default: false
    },
    isDisable: {
      default: false
    },
    data: {
      default: {}
    }
  },
  data: function() {
    return {};
  },
  methods: {
    clickHandler: function(e) {
      this.$emit("click", { ...this.data, isChecked: e.target.checked });
    }
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/ToggleButton.vue